import { useNavigate } from 'react-router-dom'
import { useContext, useEffect, useState } from 'react'
import { AppIdContext } from '../Contexts/AppIdContext'
import { URLS } from '../Utils/constants'
import * as constants from '../Utils/constants';
import LfDataService from '../../../Services/LfDataService.js';
import HeartLoader from '../../../UI/HeartLoader'


const lfDataService = new LfDataService();

/**
 * Handles the signing process for the managed pension application.
 * 
 * @param {string} appId Application id from context.
 */

/**
 * data = {
 *     appId: string,
 *     autoStartToken: string,
 *     signed: boolean
 * }
 */

function poll(data) {
    return lfDataService.getManagedPensionBankIDCurrentStatus(data)

        .then(result => {
            if (result.status === 'pending' || result.status === 'usersign') {
                return new Promise((resolve) => {
                    setTimeout(() => {
                        resolve(poll(data));
                    }, 1000);
                });
            } else {
                return result.status;
            }
        })
        .catch(e => {
            return null;
        });
}



function sign(appId) {

    const signStatus = appId => lfDataService.startManagedPensionApplicationSigning({ appId: appId })
        .then(result => {
            return {
                appId: appId,
                autoStartToken: result.autoStartToken,
                signingRef: result.signingReference,
            };
        })

    const bankIdStatus = (data) => lfDataService.getManagedPensionApplicationBankIDStatus({ appId: data.appId })
        .then(result => {
            return { ...data, signed: result.signed };
        })


    return signStatus(appId)
        .then(bankIdStatus)
}

const OpenDesktopApp = () => {

    const [polling, setPolling] = useState(false);
    const navigate = useNavigate();
    const id = useContext(AppIdContext);


     useEffect(() => {
        if (id) {
            sign(id)
                .then(data => {
                    window.location.href = `bankid:///?autostarttoken=${data.autoStartToken}&redirect=null`;
                    return data
                })
                .then(data => {
                    setPolling(true)
                    return poll(data);
                })
            .then(status => {
                if (status === 'complete') {
                    navigate(URLS.resultSuccess);
                } else {
                    navigate(URLS.resultFailed);
                }

                setPolling(false);
            })
        }
     }, [id])

    return (
        <div className="signature-process">
            <div className="signature-process__container">
                <div className="signature-process__container__card">
                    <h2 className="signature-process__container__card__headline">{constants.openApp.headline}</h2>
                  

                    { polling &&
                        <>
                            <p className="signature-process__container__card__info">Försöker starta BankID säkerhetsprogram</p>
                            <div className="signature-process__container__card__loader-container">
                                <HeartLoader />
                            </div>
                        </>
                        
                    }

                    { !polling &&
                        <button className="signature-process__container__card__link" onClick={() => navigate(URLS.selectMethod)}>
                            Öppna på annat sätt
                        </button>
                    }
                </div>
            </div>
        </div>
        )

}

export default OpenDesktopApp;